/* eslint-disable */
import { cloneDeep, update } from 'lodash';
// eslint-disable-next-line object-curly-newline
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { connect } from 'react-redux';
// eslint-disable-next-line object-curly-newline
import { useHistory, useParams } from 'react-router';
import { analyticsAction, formActions, modalActions } from '../../../Actions';
// import { DraggableHTabs } from '../../../Components/Draggable';
import { FormSectionHeader } from '../../../Components/Forms';
import { CreatePageHeader } from '../../../Components/Headers';
import { GeneralDetails } from '../../../Components/Forms/Customizations';
import { urls } from '../../../Constants';
// eslint-disable-next-line object-curly-newline
import { alterProductForSalesUnitConsumptionLogic, inputHelper, isEmpty, isSalesUnitConsumptionLogicTrue } from '../../../Helpers';
import cookingRecipeConfig, { addToStages, countStageChanges, depthFirstIntermediates, fetchProductsRecipe, findAllIntermediateProducts, findSerializedIntermediateProducts, updateForStageReferences } from './cookingRecipe.config';
import {
	RecipeDetails,
	RecipeStage,
} from '../../../Components/Forms/Cooking/Cooking Recipe';
import styles from './CookingRecipe.module.scss';
import ExportProcessModal from '../../../Components/Modals/ExportProcessModal/ExportProcessModal';
import ProductVariantsModal from '../../../Components/Modals/ProductVariantsModal/ProductVariantsModal';
import cookingRecipesServices from '../../../Services/Form Services/cookingRecipes.services';
import CookingProcessesTabs from '../../../Components/Forms/Cooking/CookingProcessesTabs/CookingProcessesTabs';
import { AlertModal } from '../../../Components/Modals';
import { notificationServices } from '@/Services';
import { cookingConfig } from '@/Pages/Food Products/All Products/cooking.config';
import ProductCookingConfig from '@/Components/Forms/Products/ProductCookingConfig';
import CookingRecipeStages from '@/Components/Cooking/CookingRecipeStages/CookingRecipeStages';
import productProcessMapServices from '../../../Services/Analytics Services/product-process-map.services';

import { MAPPING_TYPE_CONFIG } from './mapping.constants';

const CookingRecipeCreatePage = (props) => {
	const [state, setState] = useState({
		...cookingRecipeConfig.initialState,
	});
	const [activeStage, setActiveStage] = useState(1);
	const [activeProcess, setActiveProcess] = useState(
		state?.fields?.stages?.items?.[1]?.processes?.order?.[0] ?? -1
	);
	const [numberOfSubmissions, setNumberOfSubmissions] = useState(0);
	const { fields, errors } = state;
	const [cookingState, setCookingState] = useState({
		...cookingConfig?.initialState,
	});
	const [activeProduct, setActiveProduct] = useState(null);
	const [productMappingData, setProductMappingData] = useState([]);
	const [selectedMappingStoreId, setSelectedMappingStoreId] = useState(null);
	// Snapshot of the originally-loaded stage tree (keyed by product id) so that
	// on save we only update the recipes that actually changed - editing a child
	// must not create a new pending version for its unchanged parent/grandparent.
	const originalStagesRef = useRef({});

	const activeStageValue = fields.stages.items?.[activeStage];

	const {
		isEdit,
		data,
		fetchRecipe,
		fetchCookingStations,
		saveRecipe,
		breadcrumbs,
		processTypes,
		fetchProcessTypesList,
		productsMap,
		toggleAlert,
		saveProductConfig,
		fetchProductRecipe,
		recipeData,
		storesList, // Added storesList
		fetchStoresList, // Added fetchStoresList
		batches,
		fetchBatches,
	} = props;

	const history = useHistory();
	const { id } = useParams();

	useEffect(() => {
		fetchCookingStations({
			entity: 'COOKING_STATIONS',
			req: {
				params: {
					id: '',
				},
			},
			method: 'LIST',
		});
		fetchStoresList({
			entity: 'STORES',
			req: {
				params: {
					id: '',
				},
			},
			method: 'LIST',
		});
		return () => {
			setState({
				...cookingRecipeConfig.initialState,
			});
		}
	}, []);

	useEffect(() => {
		fetchProductRecipe({
			entity: 'COOKING_PRODUCT_CONFIG',
			req: {
				params: {
					id,
				},
			},
			method: 'VIEW',
		});
	}, [id]);

	useEffect(() => {
		if (isEdit) {
			if (isEmpty(data) || (!isEmpty(data) && data?.product?.id !== id)) {
				fetchRecipe({
					entity: 'RECIPES',
					req: {
						params: {
							productId: id,
						},
					},
					method: 'VIEW',
				});
			}
		}
	}, [isEdit, id]);

	useEffect(() => {
		if (processTypes.length === 0) {
			fetchProcessTypesList({
				entity: 'PROCESS_TYPES',
				req: {
					params: {
						id: '',
					},
				},
				method: 'LIST',
			});
		}
	}, [])


	const allIntermediateProducts = useMemo(() => {
		return findAllIntermediateProducts(data);
	}, [data]);

	// Nutrient Info - memoized to react to fields.product changes
	const nutrientInfo = useMemo(() => {
		const product = fields?.product || {};
		const variant = product?.variants?.[0] || {};
		const unit = product?.unit?.toLowerCase() || '';
		const isGrm = unit === 'gram' || unit === 'grm' || unit === 'gm' || unit === 'g';
		const isCount = unit === 'count' || unit === 'pc' || unit === 'pcs' || unit === 'piece';
		const perLabel = isGrm ? 'per 100g' : (isCount ? 'per 100 pc' : `per ${unit}`);

		// Use variant data first, fallback to product data
		const getNutrientValue = (key) => {
			const val = variant?.[key] ?? product?.[key] ?? 0;
			return Number(val);
		};

		const nutrients = [
			{ label: 'Calories', value: getNutrientValue('Calories'), unit: 'Kcal' },
			{ label: 'Protein', value: getNutrientValue('Protein'), unit: 'g' },
			{ label: 'Carbs', value: getNutrientValue('Carbs'), unit: 'g' },
			{ label: 'Fat', value: getNutrientValue('Fat'), unit: 'g' },
			{ label: 'Calcium', value: getNutrientValue('Calcium'), unit: 'mg' },
		];

		return { perLabel, nutrients };
	}, [fields?.product]);

	// useEffect(() => {
	// 	setCookingState(cookingConfig.serializer(cookingState, recipeData));
	// }, [recipeData]);

	useEffect(() => {
		if (!isEmpty(data) && data.product.id == id) {
			setState({
				activeTab: 0,
				fields: cloneDeep(cookingRecipeConfig.initialState.fields),
			});
			const serializedProductRecipe = cookingRecipeConfig.serializer(
				state,
				data,
				processTypes
			);
			(async () => {
				const stagesArr = cloneDeep(
					serializedProductRecipe?.fields?.stages
				);
				const count = await depthFirstIntermediates(
					allIntermediateProducts,
					{
						...stagesArr,
						stageLevel: 1,
					},
					processTypes
				);
				const { stages, ...remaining } = serializedProductRecipe?.fields;
				stagesArr.items['1'] = {
					...stagesArr.items['1'],
					recipeData: remaining,
				};
				serializedProductRecipe.fields.stages = stagesArr;
				// Keep a deep snapshot of the loaded tree to diff against on save.
				originalStagesRef.current = cloneDeep(stagesArr.items || {});
				setState(serializedProductRecipe);
			})();
			setActiveStage(1);
			// Default-select the first cooking step (order[0]) of the loaded
			// recipe, not the step count, and read from the freshly serialized
			// recipe rather than the stale pre-load state.
			setActiveProcess(
				serializedProductRecipe?.fields?.stages?.items?.[1]?.processes?.order?.[0] ?? -1
			);
		}
	}, [data, allIntermediateProducts]);

	const handleInput = (e) => {
		const { fieldName, fieldValue, dataset } = inputHelper(e);
		let error = '';
		const newState = {};
		// for form validations and error generation
		switch (fieldName) {
			case 'comboName':
				if (fieldValue.length === 0) {
					error = 'This field is required';
				} else {
					error = '';
				}
				errors[fieldName] = error;
				break;
			case 'veg':
				newState[fieldName] = fieldValue === '1';
				break;
			default:
				break;
		}
		switch (dataset.type) {
			case 'recipe':
				setState(
					update(cloneDeep(state), `fields[${fieldName}]`, () => {
						return fieldValue;
					})
				);
				break;
			case 'stage':
				setState(
					update(
						cloneDeep(state),
						`fields.stages.items[${activeStage}][${fieldName}]`,
						() => {
							return fieldValue;
						}
					)
				);
				break;
			case 'process':
				setState(
					update(
						cloneDeep(state),
						`fields.stages.items[${activeStage}].processes.items[${activeProcess}][${fieldName}]`,
						() => {
							return fieldValue;
						}
					)
				);
				break;
			case 'group':
				switch (fieldName) {
					case 'isApplied':
						setState(
							update(
								cloneDeep(state),
								`fields.stages.items[${activeStage}].processes.items[${activeProcess}].customizations.items[${dataset.parent}].applicableOn[${dataset.id}]`,
								(applicableOnObj) => {
									const newApplicableOn =
										cloneDeep(applicableOnObj);
									newApplicableOn.isApplied = fieldValue;
									return newApplicableOn;
								}
							)
						);
						break;
					case 'type':
						setState(
							update(
								cloneDeep(state),
								`fields.stages.items[${activeStage}].processes.items[${activeProcess}].customizations.items[${dataset.id}]`,
								(groupObj) => {
									// eslint-disable-next-line no-param-reassign
									groupObj[fieldName] = fieldValue;
									if (fieldValue === 'REMOVABLE') {
										// eslint-disable-next-line no-param-reassign
										groupObj.deltaPricing = false;
									}
									return groupObj;
								}
							)
						);
						break;
					default:
						setState(
							update(
								cloneDeep(state),
								`fields.stages.items[${activeStage}].processes.items[${activeProcess}].customizations.items[${dataset.id}][${fieldName}]`,
								() => {
									return fieldValue;
								}
							)
						);
						break;
				}
				break;
			case 'sku':
				if (dataset.variant) {
					setState((prevState) => {
						return update(
							cloneDeep(prevState),
							`fields.stages.items[${activeStage}].processes.items[${activeProcess}].customizations.items[1].skus[${dataset.id}].variants[${dataset.variant}][${fieldName}]`,
							() => {
								return fieldValue;
							}
						);
					});
				} else {
					setState((prevState) => {
						return update(
							cloneDeep(prevState),
							`fields.stages.items[${activeStage}].processes.items[${activeProcess}].customizations.items[1].skus[${dataset.id}][${fieldName}]`,
							() => {
								return fieldValue;
							}
						);
					});
				}
				break;
			default:
				setState({
					...state,
					fields: {
						...state.fields,
						[fieldName]: fieldValue,
						...newState,
					},
					...errors,
				});
		}
	};
	const handleRecipeDetailsInput = (e) => {
		const { fieldName, fieldValue, dataset } = inputHelper(e);
		let error = '';
		const newState = {};
		// for form validations and error generation
		switch (fieldName) {
			case 'comboName':
				if (fieldValue.length === 0) {
					error = 'This field is required';
				} else {
					error = '';
				}
				errors[fieldName] = error;
				break;
			case 'veg':
				newState[fieldName] = fieldValue === '1';
				break;
			default:
				break;
		}

		switch (dataset.type) {
			case 'recipe':
				setState(
					update(cloneDeep(state), `fields[${fieldName}]`, () => {
						return fieldValue;
					})
				);
				break;
			case 'stage':
				setState(
					update(
						cloneDeep(state),
						`fields.stages.items[${activeStage}].recipeData[${fieldName}]`,
						() => {
							return fieldValue;
						}
					)
				);
				break;
			case 'process':
				setState(
					update(
						cloneDeep(state),
						`fields.stages.items[${activeStage}].processes.items[${activeProcess}][${fieldName}]`,
						() => {
							return fieldValue;
						}
					)
				);
				break;
			case 'group':
				switch (fieldName) {
					case 'isApplied':
						setState(
							update(
								cloneDeep(state),
								`fields.stages.items[${activeStage}].processes.items[${activeProcess}].customizations.items[${dataset.parent}].applicableOn[${dataset.id}]`,
								(applicableOnObj) => {
									const newApplicableOn =
										cloneDeep(applicableOnObj);
									newApplicableOn.isApplied = fieldValue;
									return newApplicableOn;
								}
							)
						);
						break;
					case 'type':
						setState(
							update(
								cloneDeep(state),
								`fields.stages.items[${activeStage}].processes.items[${activeProcess}].customizations.items[${dataset.id}]`,
								(groupObj) => {
									// eslint-disable-next-line no-param-reassign
									groupObj[fieldName] = fieldValue;
									if (fieldValue === 'REMOVABLE') {
										// eslint-disable-next-line no-param-reassign
										groupObj.deltaPricing = false;
									}
									return groupObj;
								}
							)
						);
						break;
					default:
						setState(
							update(
								cloneDeep(state),
								`fields.stages.items[${activeStage}].processes.items[${activeProcess}].customizations.items[${dataset.id}][${fieldName}]`,
								() => {
									return fieldValue;
								}
							)
						);
						break;
				}
				break;
			case 'isBulk':
				setState((prevState) => {
					return update(
						cloneDeep(prevState),
						`fields.stages.items[${activeStage}].recipeData.isBulk`,
						() => {
							return fieldValue;
						}
					);
				});
				break;
			case 'sku':
				if (dataset.variant) {
					setState((prevState) => {
						return update(
							cloneDeep(prevState),
							`fields.stages.items[${activeStage}].processes.items[${activeProcess}].customizations.items[1].skus[${dataset.id}].variants[${dataset.variant}][${fieldName}]`,
							() => {
								return fieldValue;
							}
						);
					});
				} else {
					setState((prevState) => {
						return update(
							cloneDeep(prevState),
							`fields.stages.items[${activeStage}].processes.items[${activeProcess}].customizations.items[1].skus[${dataset.id}][${fieldName}]`,
							() => {
								return fieldValue;
							}
						);
					});
				}
				break;
			default:
				setState({
					...state,
					fields: {
						...state.fields,
						[fieldName]: fieldValue,
						...newState,
					},
					...errors,
				});
		}
	};

	const handleBatchSize = (e, variantId) => {
		const newObj = {
			...fields?.stages?.items?.[activeStage]?.recipeData?.batchSize,
			[`${variantId}`]: Number(e?.target?.value),
		};
		setState(
			update(cloneDeep(state), `fields.stages.items[${activeStage}].recipeData.batchSize`, () => {
				return newObj;
			})
		);
	};

	// cooking config
	const handleCookingInput = (e) => {
		const { fieldName, fieldValue } = inputHelper(e);
		setCookingState((prevState) => {
			const newFields = {
				...prevState?.fields,
			};
			newFields[fieldName] = fieldValue;
			return {
				...prevState,
				fields: newFields,
			};
		});
	};


	// const addNewStage = () => {
	// 	let newLen = activeStage;
	// 	let newState = update(
	// 		cloneDeep(state),
	// 		'fields.stages.order',
	// 		(arr) => {
	// 			let len = 1;
	// 			if (arr.length > 0) {
	// 				len = Math.max(...arr) + 1;
	// 			}
	// 			arr.push(len);
	// 			newLen = len;
	// 			return arr;
	// 		}
	// 	);
	// 	newState = update(newState, 'fields.stages.items', (obj) => {
	// 		const newObj = {
	// 			...obj,
	// 		};
	// 		const { newStageObj } = cloneDeep(cookingRecipeConfig);
	// 		newStageObj.id = newLen;
	// 		newStageObj.name = `Stage ${newLen}`;
	// 		newObj[newLen] = newStageObj;
	// 		return newObj;
	// 	});

	// 	setState(newState);
	// 	setActiveStage(newLen);
	// };

	const handleStageReOrdering = (dragIndex, hoverIndex) => {
		const newState = update(
			cloneDeep(state),
			'fields.stages.order',
			(arr) => {
				const dragObj = arr[dragIndex];
				arr.splice(dragIndex, 1);
				arr.splice(hoverIndex, 0, dragObj);
				return arr;
			}
		);
		setState(newState);
	};

	const addDependencies = (currentStage, addedDependencies) => {
		const newState = update(
			cloneDeep(state),
			`fields.stages.items[${currentStage}].dependencies`,
			(arr) => {
				const newArr = [...arr, ...addedDependencies];
				return newArr;
			}
		);
		setState(newState);
	};

	const removeDependency = (currentStage, removedDependency) => {
		const newState = update(
			cloneDeep(state),
			`fields.stages.items[${currentStage}].dependencies`,
			(arr) => {
				const newArr = [...arr];
				newArr.splice(removedDependency, 1);
				return newArr;
			}
		);
		setState(newState);
	};

	const addNewProcess = () => {
		let newLen = activeProcess;
		let newState = update(
			cloneDeep(state),
			`fields.stages.items[${activeStage}].processes.order`,
			(arr) => {
				let len = 1;
				if (arr.length > 0) {
					len = Math.max(...arr) + 1;
				}
				arr.push(len);
				newLen = len;
				return arr;
			}
		);
		newState = update(
			newState,
			`fields.stages.items[${activeStage}].processes.items`,
			(obj) => {
				const newObj = {
					...obj,
				};
				const { newProcessObj } = cloneDeep(cookingRecipeConfig);
				newProcessObj.id = newLen;
				newProcessObj.name = `Step ${newLen}`;
				newProcessObj.customizations.items[1].applicableOn =
					fields.product.variants.map((variant) => {
						return {
							id: variant.id,
							name: variant.displayName,
							size: variant.size,
							isApplied: false,
						};
					});
				newObj[newLen] = newProcessObj;
				return newObj;
			}
		);

		setState(newState);
		setActiveProcess(newLen);
	};

	const handleProcessReOrdering = (dragIndex, hoverIndex) => {
		const newState = update(
			cloneDeep(state),
			`fields.stages.items[${activeStage}].processes.order`,
			(arr) => {
				const dragObj = arr[dragIndex];
				arr.splice(dragIndex, 1);
				arr.splice(hoverIndex, 0, dragObj);
				return arr;
			}
		);
		setState(newState);
	};

	const exportProcess = (stageConfig) => {
		const { from, to, processId } = stageConfig;

		const clonedState = cloneDeep(state);

		setState(
			update(clonedState, 'fields.stages', (stages) => {
				const newStages = stages;
				const fromProcesses = newStages.items[from].processes;
				// get process object
				const processObj = fromProcesses.items[processId];

				// add process to the 'to' stage's processes' items and order
				const toProcesses = newStages.items[to].processes;
				// get max processId
				const maxProcessId =
					toProcesses.order.length > 0
						? Math.max(...toProcesses.order)
						: 0;
				// set the new processId as max + 1
				const newProcessId = maxProcessId + 1;
				processObj.id = newProcessId;
				// add it to items and order
				toProcesses.items[newProcessId] = processObj;
				toProcesses.order.push(newProcessId);

				// remove process from the 'from' stage's processes' items and order
				delete fromProcesses.items[processId];
				fromProcesses.order = fromProcesses.order.filter((pId) => {
					return pId !== parseInt(processId, 10);
				});
				return newStages;
			})
		);
	};

	const addSKUs = async ({ productId, variantId, price }) => {
		let sku = productsMap[productId];
		sku = cloneDeep(sku);
		let clonedState = cloneDeep(state);
		let newUnit = sku?.unit;
		if (isSalesUnitConsumptionLogicTrue(sku)) {
			sku = alterProductForSalesUnitConsumptionLogic(sku);
		}
		const stagesValuesArr = Object.entries(clonedState?.fields?.stages?.items ?? {});
		if (sku?.skuType === 'INTERMEDIATE' || sku?.skuType === 'PRODUCT' || sku?.skuType === 'UNPACKED_PRODUCT') {
			// const intermediateRecipe = await fetchIntermediateRecipe(sku?.id);
			// const intermediatesIntermediateProd =
			// 	findSerializedIntermediateProducts(intermediateRecipe);
			// // console.log(
			// // 	'intermediatesIntermediateProd',
			// // 	intermediatesIntermediateProd
			// // );
			let stagesObj = clonedState.fields.stages;
			// if (!isIntermediateAlreadyAdded) {
			// 	const stagesArr = Object.values(stagesObj?.items);

			// 	stagesArr?.splice(Number(activeStage), 0, {
			// 		...intermediateRecipe?.stages?.items?.['1'],
			// 		isIntermediate: true,
			// 		forStage: [Number(activeStage)],
			// 	});
			// 	stagesObj?.order?.push(Number(activeStage));

			// 	stagesObj.items = stagesArr?.reduce((acc, ele, index) => {
			// 		acc[index + 1] = ele;
			// 		return acc;
			// 	}, {});
			// 	stagesObj.items = updateForStageReferences(
			// 		stagesObj.items,
			// 		Number(activeStage) + 1,
			// 		1
			// 	);
			// } else {
			// 	stagesObj.items[isIntermediateAlreadyAdded?.[0]] = {
			// 		...stagesObj.items?.[isIntermediateAlreadyAdded?.[0]],
			// 		forStage: [
			// 			...stagesObj.items?.[isIntermediateAlreadyAdded?.[0]]?.forStage,
			// 			Number(activeStage)
			// 		]
			// 	};
			// }
			let newStagesObj = cloneDeep(stagesObj);
			// newStagesObj = {
			// 	...newStagesObj,
			// 	stageLevel: Number(activeStage) + 1,
			// };
			// let itemsAddedCount = await depthFirstIntermediates(
			// 	intermediatesIntermediateProd,
			// 	newStagesObj,
			// 	processTypes,
			// 	Number(activeStage) + 1
			// );
			// console.log('itemsAddedCount', itemsAddedCount);
			newStagesObj = await addToStages({
				productsArr: [
					{
						...sku,
						unit: newUnit,
						skuId: sku?.id,
					},
				],
				addToIndex: Number(activeStage) + 1,
				activeStage: Number(activeStage),
				processTypes,
				currentStagesAcc: newStagesObj,
			});
			// newStagesObj.items = updateForStageReferences(
			// 	newStagesObj.items,
			// 	Number(activeStage) + 1,
			// 	itemsAddedCount
			// );
			// const newStageId = clonedState.fields.stages.order.length + 1;

			// const newStage = {
			// 	id: 1,
			// 	stageId: intermediateRecipe?.product?.id,
			// 	name: intermediateRecipe?.product?.productName,
			// 	station: intermediateRecipe?.recipe?.stages?.[0]?.stationId,
			// 	instructions: intermediateRecipe?.recipe?.stages?.[0]?.stageDescription,
			// 	isDependent: intermediateRecipe?.recipe?.stages?.[0]?.stageDependency?.length > 0 ?? false,
			// 	dependencies: intermediateRecipe?.recipe?.stages?.[0]?.stageDependency,
			// 	processes: intermediateRecipe?.recipe?.stages?.[0]?.processes,
			// };

			// let stagesObj = clonedState.fields.stages;
			// const stagesArr = Object.values(stagesObj?.items);

			// stagesArr?.splice(Number(activeStage), 0, {
			// 	...intermediateRecipe?.stages?.items?.['1'],
			// 	isIntermediate: true,
			// 	forStage: activeStage,
			// });

			// stagesObj.items = stagesArr?.reduce((acc, ele, index) => {
			// 	acc[index + 1] = ele;
			// 	return acc;
			// }, {});

			// const newOrder = stagesObj?.order?.length + 1;
			// // stagesObj.items[newOrder] = {
			// // 	...intermediateRecipe?.stages?.items?.['1'],
			// // 	isIntermediate: true,
			// // };
			// stagesObj?.order?.push(newOrder);

			clonedState.fields.stages = newStagesObj;
		}
		const selectedRecipe = clonedState?.fields?.stages?.items?.[activeStage]?.recipeData;
		const finalObj = {
			id: null,
			skuId: productId,
			variantId,
			isDefault: false,
			unit: sku.unit,
			skuType: sku?.skuType,
			variants: selectedRecipe?.product?.variants?.map((variant) => ({
				qty: undefined,
				price,
				id: variant.id,
			})),
		};

		const skusPath = `fields.stages.items[${activeStage}].processes.items[${activeProcess}].customizations.items[1].skus`;
		clonedState = update(clonedState, skusPath, (skusArr) => {
			skusArr.push(finalObj);
			return skusArr;
		});

		// console.log('clonedState', clonedState);
		setState(clonedState);
	};

	const findAllSubProcess = (stagesState, processOfKey) => {
		const processIds = [];
		const findProcesses = (key) => {
			const keys = Object.keys(stagesState)?.filter((eleKey) => {
				const eleValue = stagesState[eleKey];
				return eleValue?.forStage?.includes(Number(key));
			});
			keys?.forEach((currKey) => {
				// Only recurse into keys we haven't seen yet. Recursing
				// unconditionally causes infinite recursion (stack overflow)
				// when the forStage dependency graph contains a cycle.
				if (!processIds?.includes(currKey)) {
					processIds?.push(currKey)
					findProcesses(currKey);
				}
			})
		}
		findProcesses(processOfKey);
		return processIds;
	}

	const findAllSubProcess2 = (stagesState, processOfKey) => {
		const processIds = [];
		const visited = new Set(); // Track visited keys to prevent cycles
		const stack = [processOfKey];

		while (stack.length > 0) {
			const currentKey = stack.pop();
			if (visited.has(currentKey)) {
				continue;
			}
			visited.add(currentKey);

			const keys = Object.keys(stagesState).filter((eleKey) => {
				const eleValue = stagesState[eleKey];
				return eleValue?.forStage?.includes(Number(currentKey));
			});

			keys.forEach((key) => {
				if (!processIds.includes(key)) {
					processIds.push(key);
				}
				stack.push(key); // Add to stack for further processing
			});
		}

		return processIds;
	};


	const handleDelete = (e) => {
		const { dataset } = inputHelper(e);
		switch (dataset.type) {
			case 'stage':
				setState(
					update(cloneDeep(state), 'fields.stages', (stages) => {
						const newState = stages;

						// Remove SKUs associated with the stage being deleted
						stages.items['1'].processes.items = Object.entries(
							stages.items['1'].processes.items
						).reduce((acc, [key, value]) => {
							acc[key] = {
								...value,
								customizations: {
									...value.customizations,
									items: {
										...value.customizations.items,
										['1']: {
											...value.customizations.items['1'],
											skus: value.customizations.items[
												'1'
											].skus.filter(
												(sku) =>
													sku.skuId !==
													stages.items[activeStage]
														?.stageProduct?.id
											),
										},
									},
								},
							};
							return acc;
						}, {});

						delete newState.items[activeStage];
						const subProcesses = findAllSubProcess(newState?.items, activeStage);

						subProcesses.forEach((subProcessKey) => {
							delete newState.items[subProcessKey];
						});

						newState.order = fields.stages.order.filter((stage) => {
							return stage !== activeStage;
						});
						// remove the deleted stage from other stages' dependencies
						for (
							let stageIdx = 0;
							stageIdx < newState.order.length;
							stageIdx++
						) {
							const stageId = newState.order[stageIdx];
							const stage = stages.items[stageId];
							if (stage) {
								stage.dependencies =
									stage?.dependencies?.filter((dep) => {
										return dep !== activeStage;
									});
							}
						}
						// if number of stages after removal is greater than 0
						// set active stage as the first one
						if (newState.order.length > 0) {
							const firstStageId = stages.order[0];
							setActiveStage(firstStageId);
							// if number of processes are greater than 0
							// set active process as the first one
							if (
								newState.items[firstStageId].processes.order
									.length > 0
							) {
								const firstProcessId =
									stages.items[firstStageId].processes
										.order[0];
								setActiveProcess(firstProcessId);
							} else {
								// else set as -1
								setActiveProcess(-1);
							}
						} else {
							// else set as -1
							setActiveStage(-1);
							setActiveProcess(-1);
						}
						return newState;
					})
				);
				break;
			case 'process':
				setState((prevState) => {
					const newState = cloneDeep(prevState);
					const stages = newState.fields.stages;
					const processes = stages.items[activeStage].processes;
					const processItems =
						processes.items[activeProcess].customizations.items?.[1]
							?.skus;

					// Check for items with skuType 'INTERMEDIATE'
					let intermediateSkuIds = [];
					Object.values(processItems).forEach((item) => {
						if (item.skuType === 'INTERMEDIATE' || item.skuType === 'PRODUCT' || item.skuType === 'UNPACKED_PRODUCT') {
							intermediateSkuIds.push(item.skuId);
						}
					});

					// Delete the process
					delete processes.items[activeProcess];
					processes.order = processes.order.filter(
						(process) => process !== activeProcess
					);

					let stagesToCheck = new Set();
					// Find the stage and subprocesses for each INTERMEDIATE skuId
					intermediateSkuIds.forEach((skuId) => {
						const stageWithIntermediateProduct = Object.entries(
							stages.items
						).find(
							([stageKey, stageValue]) =>
								stageValue?.stageProduct?.id === skuId
						);

						if (stageWithIntermediateProduct) {
							const subProcesses = findAllSubProcess2(
								stages.items,
								stageWithIntermediateProduct?.[0]
							);
							subProcesses?.push(
								stageWithIntermediateProduct?.[0]
							);

							const multiForStages = [];
							const deletedStageKey = [];
							subProcesses.forEach((subProcessKey) => {
								const stage = stages.items[subProcessKey];
								if (stage?.forStage?.length === 1) {
									delete stages.items[subProcessKey];
									stages?.order?.pop();
									deletedStageKey.push(Number(subProcessKey));
									stagesToCheck.add(
										stageWithIntermediateProduct[0]
									);
								} else {
									multiForStages.push(subProcessKey);
								}
							});
							if (
								multiForStages.length ||
								deletedStageKey.length
							) {
								multiForStages.forEach((eleKey) => {
									const eleValue =
										newState.fields.stages.items[eleKey];
									if (
										eleValue?.forStage?.includes(
											Number(activeStage)
										)
									) {
										deletedStageKey?.push(
											Number(activeStage)
										);
									}
									newState.fields.stages.items[eleKey] = {
										...eleValue,
										forStage: eleValue?.forStage?.filter(
											(stageKey) => {
												return !deletedStageKey?.includes(
													stageKey
												);
											}
										),
									};
									if (
										!newState.fields.stages.items[eleKey]
											?.forStage?.length
									) {
										delete newState.fields.stages.items[
											eleKey
										];
										newState.fields.stages?.order?.pop();
									}
								});
							}
						}
					});

					// Function to remove stale stages
					const removeStaleStages = () => {
						let staleFound = false;
						stagesToCheck.forEach((stageKey) => {
							const stage = stages.items[stageKey];
							if (!stage) return;

							const validForStages =
								stage.forStage?.filter(
									(forStageKey) => stages.items[forStageKey]
								) || [];

							if (
								validForStages.length !== stage.forStage.length
							) {
								staleFound = true;
							}

							stage.forStage = validForStages;

							if (!validForStages.length) {
								delete stages.items[stageKey];
								stages.order = stages.order.filter(
									(orderKey) => orderKey !== stageKey
								);
							}
						});

						return staleFound;
					};

					// Check and remove stale stages iteratively
					let staleStagesExist;
					do {
						staleStagesExist = removeStaleStages();
					} while (staleStagesExist);

					// Set the active process
					if (processes.order.length > 0) {
						setActiveProcess(processes.order[0]);
					} else {
						setActiveProcess(-1);
					}

					return newState;
				});
				break;
			case 'sku':
				setState((prevState) => {
					const newState = cloneDeep(prevState);
					const stages = newState.fields.stages;
					const sku =
						stages.items?.[activeStage]?.processes?.items?.[
							activeProcess
						]?.customizations?.items?.[1]?.skus?.[dataset.id];

					const stageWithIntermediateProduct = Object.entries(
						stages.items
					).find(
						([stageKey, stageValue]) =>
							stageValue?.stageProduct?.id === sku?.skuId
					);

					if (stageWithIntermediateProduct) {
						const subProcesses = findAllSubProcess(
							stages.items,
							stageWithIntermediateProduct?.[0]
						);
						subProcesses?.push(stageWithIntermediateProduct?.[0]);

						const multiForStages = [];
						const deletedStageKey = [];
						subProcesses.forEach((subProcessKey) => {
							const stage = stages.items[subProcessKey];
							if (stage?.forStage?.length === 1) {
								delete stages.items[subProcessKey];
								stages?.order?.pop();
								deletedStageKey.push(Number(subProcessKey));
							} else {
								multiForStages.push(subProcessKey);
							}
						});
						if (multiForStages.length || deletedStageKey.length) {
							multiForStages.forEach((eleKey) => {
								const eleValue =
									newState.fields.stages.items[eleKey];
								if (
									eleValue?.forStage?.includes(
										Number(activeStage)
									)
								) {
									deletedStageKey?.push(Number(activeStage));
								}
								newState.fields.stages.items[eleKey] = {
									...eleValue,
									forStage: eleValue?.forStage?.filter(
										(stageKey) => {
											return !deletedStageKey?.includes(
												stageKey
											);
										}
									),
								};
								if (
									!newState.fields.stages.items[eleKey]
										?.forStage?.length
								) {
									delete newState.fields.stages.items[eleKey];
									newState.fields.stages?.order?.pop();
								}
							});
						}
					}
					stages.items?.[activeStage]?.processes?.items?.[
						activeProcess
					]?.customizations?.items?.[1]?.skus?.splice(dataset.id, 1);
					return newState;
				})
				// setState(
				// 	update(
				// 		cloneDeep(state),
				// 		`fields.stages.items[${activeStage}].processes.items[${activeProcess}].customizations.items[1].skus`,
				// 		(skusArr) => {
				// 			const newState = skusArr;
				// 			console.log('dataset.id', dataset.id);
				// 			newState.splice(dataset.id, 1);
				// 			return newState;
				// 		}
				// 	)
				// );
				break;
			default:
				break;
		}
	};


	const handleAlertConfirm = () => {
		// const isValid = cookingRecipeConfig.validator(state);
		// const keys = Object.keys(state.fields.stages.items);
		// const stagesState = Object.values(state.fields.stages.items)?.filter(
		// 	(stageValue) => {
		// 		return stageValue?.processes?.order?.length && !isEmpty(stageValue?.recipeData?.batchSize ?? {}) && stageValue?.station;
		// 	}
		// );
		// An SFG ingredient whose own recipe is not defined yet gets an empty placeholder stage
		// (serializer sets recipeData.isRecipeEmpty). Leave such stages out of validation and
		// saving unless someone filled them in, so the SFG can be used as a plain ingredient.
		// The recipe being edited is always kept.
		const stagesState = Object.values(state.fields.stages.items).filter((stageValue) => {
			const isMainProduct = Number(stageValue?.stageProduct?.id) === Number(state?.fields?.product?.id);
			const isUndefinedSfg = stageValue?.recipeData?.isRecipeEmpty && !(stageValue?.processes?.order?.length > 0);
			return isMainProduct || !isUndefinedSfg;
		});
		// keys.splice(0, 1);
		const isStagesValid = stagesState.every((stageValue) => {
			const reqStageState = {
				fields: {
					stages: {
						items: {
							1: stageValue,
						},
					},
					...stageValue.recipeData,
				},
			};
			const isStageStateValid =
				cookingRecipeConfig.validator(reqStageState);
			return isStageStateValid;
		});
		// Only persist the stages that actually changed vs. the loaded snapshot.
		// New stages (not present in the snapshot) are always saved; an unchanged
		// parent/grandparent must NOT be re-saved (which would version it and put
		// it back into APPROVAL_PENDING) just because a child below it changed.
		const originalByProductId = {};
		Object.values(originalStagesRef.current || {}).forEach((origStage) => {
			const pid = origStage?.stageProduct?.id;
			if (pid != null) originalByProductId[pid] = origStage;
		});
		const changedStages = stagesState.filter((stageValue) => {
			const pid = stageValue?.stageProduct?.id;
			const origStage = pid != null ? originalByProductId[pid] : null;
			if (!origStage) return true; // newly added stage
			return countStageChanges(stageValue, origStage) > 0;
		});

		const reqArr = changedStages.map((stageValue) => {
			const reqStageState = {
				fields: {
					stages: {
						items: {
							1: stageValue,
						},
					},
					...stageValue.recipeData,
				},
			};
			return {
				data: cookingRecipeConfig.deserializer(reqStageState),
				params: {
					productId: reqStageState.fields.product.id,
				},
			};
		});
		// const req = {};
		if (isStagesValid) {
			if (!changedStages.length) {
				notificationServices.generateNotification({
					type: 'success',
					message: 'No changes to save',
				});
				history.push(`${urls.EXTENSION}${urls.COOKING_RECIPE}`);
				return;
			}
			changedStages.forEach((stageValue) => {
				const tempStageState = {
					fields: {
						isEnabled: stageValue.isEnabled,
						isCMSEnabled: stageValue.isCMSEnabled,
						timeReq: stageValue.recipeData?.totalCookingTime || 0,
					}
				};
				const req = {
					data: cookingConfig.deserializer(tempStageState).fields,
					params: {
						id: stageValue.stageProduct.id,
					},
				};
				saveProductConfig({
					entity: 'COOKING_PRODUCT_CONFIG',
					req,
					method: 'UPDATE',
					showNotification: false,
				});
			});
			// req.params = {
			// 	productId: fields.product.id,
			// };
			const callArr = reqArr?.map((ele) => {
				return cookingRecipesServices.gateway({
					req: ele,
					method: 'UPDATE',
				});
			});
			Promise.all(callArr)
				.then((values) => {
					// A backend validation error can slip through as a RESOLVED response
					// with a non-200 statusCode. Only treat the save as successful (and
					// navigate away) when every call is OK; otherwise stay on the page so
					// the user can fix the recipe and retry without losing their edits.
					const failed = (values || []).some(
						(v) => v && v.statusCode && v.statusCode !== 200
					);
					if (failed) {
						notificationServices.generateNotification({
							type: 'error',
							message: 'Recipe save failed. Please fix the issues and try again.',
						});
						return;
					}
					notificationServices.generateNotification({
						type: 'success',
						message: 'Recipe Successfully saved'
					});
					history.push(`${urls.EXTENSION}${urls.COOKING_RECIPE}`);
				})
				.catch(() => {
					// Save was rejected. handleResponse already surfaced the specific
					// error; swallow it here so the page does NOT navigate away or leave an
					// unhandled rejection — the user keeps their edits to fix and retry.
				});
		}
	};

	const handleSave = (e) => {
		e.preventDefault();
		toggleAlert(true, {
			heading: 'Are you Sure?',
			handleConfirm: () => {
				handleAlertConfirm();
				toggleAlert(false);
			},
			colorReverse: false,
			cancelText: 'Cancel',
			confirmText: 'Save',
			message: 'Changes in Recipe of Intermediate proudct will update the recipe of All the products using this intermediate.',
		});
	};

	const handleCancel = () => {
		if (isEdit) {
			history.push(`${urls.EXTENSION}${urls.COOKING_RECIPE}/view/${id}`);
		} else {
			history.push(`${urls.EXTENSION}${urls.COOKING_RECIPE}`);
		}
	};

	const productVariantsGroups = useMemo(() => {
		const selectedSkus =
			fields.stages.items[activeStage]?.processes.items[activeProcess]
				?.customizations.items[1].skus ?? [];
		return {
			1: {
				choices: selectedSkus.map((skuObj) => {
					return {
						productId: skuObj.skuId,
						variantId: skuObj.variantId,
					};
				}),
			},
		};
	}, [activeStage, activeProcess, fields.stages.items]);

	useEffect(() => {
		if (fields.stages.items[activeStage]?.stageProduct?.id) {
			setActiveProduct(fields.stages.items[activeStage]?.stageProduct?.id);
		}
	}, [activeStage, fields.stages.items]);

	// Set default mapping store to first BASE store
	useEffect(() => {
		if (!selectedMappingStoreId && storesList?.length > 0) {
			const baseStore = storesList.find((s) => s?.type === 'BASE');
			if (baseStore?.id) {
				setSelectedMappingStoreId(baseStore.id);
				fetchBatches(baseStore.id);
			};
		}
	}, [storesList]);

	// When a stage is selected from the sidebar, also default-select its first
	// cooking step so Step 1 is highlighted instead of leaving the previous
	// stage's step (or no step) active.
	const handleActiveStageChange = (key) => {
		setActiveStage(key);
		const order = fields.stages.items[key]?.processes?.order;
		setActiveProcess(order?.length ? order[0] : -1);
	};

	const handleMappingStoreChange = (value) => {
		setSelectedMappingStoreId(value);
		fetchBatches(value);
	}

	// Fetch product-wise mapping data
	useEffect(() => {
		const fetchMappingData = async () => {
			if (!selectedMappingStoreId) return;
			const productIds = Object.values(fields.stages.items)
				?.map((item) => item?.stageProduct?.id)
				?.filter(Boolean);
			if (!productIds?.length) return;
			try {
				const response = await productProcessMapServices.fetchProductWiseMappingData({
					data: {
						store: { id: selectedMappingStoreId },
						mappingTypes: MAPPING_TYPE_CONFIG.map((cfg) => cfg.mappingId),
						categoryId: null,
						products: productIds,
					},
				});
				if (response?.responseCode === 'SS-001') {
					setProductMappingData(response?.data?.productwiseMappings ?? []);
				}
			} catch (error) {
				console.error('Error fetching product mapping data:', error);
			}
		};
		fetchMappingData();
	}, [selectedMappingStoreId, fields.stages.items]);



	// Update stage processes based on mappings
	useEffect(() => {
		setState((prevState) => {
			const updatedItems = cloneDeep(prevState.fields.stages.items);
			let hasUpdates = false;

			Object.keys(updatedItems).forEach((key) => {
				const stage = updatedItems[key];
				const productId = stage?.stageProduct?.id;
				if (productId) {
					// Find mapping for this product with type 1 (Process)
					const mapping = productMappingData.find(
						(m) => m.productId === productId && m.mappingTypeId === 1
					);
					if (mapping) {
						const processId = Number(mapping.mappingTypeElementValue);
						const foundProcess = processTypes.find((p) => p.id == processId);
						if (foundProcess) {
							const newProcess = {
								...foundProcess.data,
								id: foundProcess.id,
								heading: mapping.mappingTypeElement || foundProcess.data.heading,
							};
							if (stage.process?.id !== newProcess.id || stage.process?.heading !== newProcess.heading) {
								stage.process = newProcess;
								hasUpdates = true;
							}
						}
					} else {
						const warningText = 'Factory Yield Capture Layout Not Mapped';
						if (stage.process?.heading !== warningText) {
							stage.process = {
								...stage.process,
								heading: warningText,
								color: '#D83838',
							};
							hasUpdates = true;
						}
					}
				}
			});

			if (!hasUpdates) return prevState;

			return {
				...prevState,
				fields: {
					...prevState.fields,
					stages: {
						...prevState.fields.stages,
						items: updatedItems,
					},
				},
			};
		});
	}, [productMappingData, processTypes]);

	const activeStageMappings = useMemo(() => {
		const productId = fields?.stages?.items?.[activeStage]?.stageProduct?.id;
		if (!productId) return [];
		return productMappingData?.filter((m) => m?.productId === productId) ?? [];
	}, [productMappingData, activeStage, fields?.stages?.items]);

	const totalRecipeCookingTime = useMemo(() => {
		let totalTimeRequired = 0;
		Object.values(state?.fields?.stages?.items)?.forEach((stageValue) => {
			Object.values(stageValue?.processes?.items)?.forEach(
				(processValue) => {
					totalTimeRequired += Number(processValue?.time ?? 0);
				}
			);
		});
		return totalTimeRequired;
	}, [state?.fields]);

	return (
		<div className={`${isEdit ? styles.edit : styles.create} root`}>
			<ProductVariantsModal
				groups={productVariantsGroups}
				handleConfirm={addSKUs}
				salesUnitAsUnitForRecipe={true}
				activeProduct={activeProduct}
				excludeProductIds={true}
			/>
			<AlertModal />
			<ExportProcessModal handleConfirm={exportProcess} />
			<form onSubmit={handleSave}>
				<CreatePageHeader
					heading='Edit Recipe'
					handleSave={handleSave}
					handleCancel={handleCancel}
					breadcrumbs={[
						...breadcrumbs,
						{
							link: '',
							name: isEdit
								? `Edit ${fields.product.productName}`
								: 'Create new',
						},
					]}
					showBreadcrumbs
				/>
				{/* product details */}
				<FormSectionHeader
					tooltip='Description for the section'
					sectionName='Product Details'
				>
					<GeneralDetails fields={fields} />
				</FormSectionHeader>
				{/* cooking config */}
				{/* <FormSectionHeader
					tooltip='Description for the section'
					sectionName='Cooking Config'
				>
					<ProductCookingConfig
						fields={cookingState?.fields}
						handleInput={handleCookingInput}
						mandatoryFeilds={cookingState?.mandatoryFeilds}
					/>
				</FormSectionHeader> */}
				{/* recipe details */}
				<FormSectionHeader sectionName='Recipe Details'>
					{/* <RecipeDetails
						fields={fields}
						mandatoryFields={cookingRecipeConfig.mandatoryFields}
						errors={errors}
						handleInput={handleInput}
						handleBatchSize={handleBatchSize}
					/> */}
					{/* Nutrient Info Section */}
					<div className='bg-white border border-gray-200 rounded-lg p-4 mb-4'>
						<h3 className='text-lg font-semibold mb-3 text-gray-800'>
							Nutrient Info <span className='text-sm font-normal text-gray-500'>({nutrientInfo.perLabel})</span>
						</h3>
						<div className='grid grid-cols-5 gap-4'>
							{nutrientInfo.nutrients.map((nutrient) => (
								<div key={nutrient.label} className='text-center p-3 bg-gray-50 rounded-lg'>
									<div className='text-sm text-gray-500'>{nutrient.label}</div>
									<div className='text-xl font-bold text-gray-800'>
										{nutrient.value}
										<span className='text-sm font-normal text-gray-500 ml-1'>{nutrient.unit}</span>
									</div>
								</div>
							))}
						</div>
					</div>
					<div className='mt-2 mb-10 w-full m-auto border border-slate-600' />
					<CookingRecipeStages
						fields={fields}
						setActiveStage={handleActiveStageChange}
						activeStage={activeStage}
						cookingRecipeConfig={cookingRecipeConfig}
						activeProcess={activeProcess}
						setActiveProcess={setActiveProcess}
						totalRequiredTime={totalRecipeCookingTime}
						activeStageMappings={activeStageMappings}
						mappingTypeConfig={MAPPING_TYPE_CONFIG}
						storesList={storesList?.filter((s) => s?.type === 'BASE')}
						selectedMappingStoreId={selectedMappingStoreId}
						onMappingStoreChange={handleMappingStoreChange}
						isDisabled={false}
						handleInput={handleInput}
						handleDelete={handleDelete}
						handleProcessReOrdering={handleProcessReOrdering}
						addNewProcess={addNewProcess}
						addDependencies={addDependencies}
						removeDependency={removeDependency}
						handleRecipeDetailsInput={handleRecipeDetailsInput}
						handleBatchSize={handleBatchSize}
						errors={errors}
						batches={batches}
					/>
				</FormSectionHeader>
			</form>
		</div>
	);
};

const mapStateToProps = (state) => {
	const data = state.form.RECIPES.data.VIEW;
	const skusModalObj = state.modal.skus;
	const productsMap = state.product.products;
	const processTypes = state?.form?.PROCESS_TYPES?.data?.LIST;
	const recipeData = state.form.COOKING_PRODUCT_CONFIG.data.VIEW;
	const batches = state?.analytics?.INGREDIENT_LIST;
	return {
		data,
		skusModalObj,
		productsMap,
		processTypes,
		recipeData,
		storesList: state?.form?.STORES?.data?.LIST,
		batches,
	};
};

const mapDispatchToProps = {
	fetchCookingStations: formActions.gateway,
	fetchRecipe: formActions.gateway,
	saveRecipe: formActions.gateway,
	fetchProcessTypesList: formActions.gateway,
	toggleAlert: modalActions.toggleAlert,
	saveProductConfig: formActions.gateway,
	fetchProductRecipe: formActions.gateway,
	fetchStoresList: formActions.gateway,
	fetchBatches: analyticsAction.getIngredients,
};

CookingRecipeCreatePage.defaultProps = {
	isEdit: false,
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(CookingRecipeCreatePage);
